/**
 * Copyright 2022 Google LLC.
 * Copyright (c) Microsoft Corporation.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview The entry point to the BiDi Mapper namespace.
 * Other modules should only access exports defined in this file.
 * XXX: Add ESlint rule for this (https://github.com/import-js/eslint-plugin-import/blob/main/docs/rules/no-restricted-paths.md)
 */
export {BidiServer} from './BidiServer.js';
export {MapperOptions} from './MapperOptions.js';
export type {CdpConnection} from '../cdp/CdpConnection.js';
export type {CdpClient} from '../cdp/CdpClient.js';
export {EventEmitter} from '../utils/EventEmitter.js';
export type {BidiTransport} from './BidiTransport.js';
export {OutgoingMessage} from './OutgoingMessage.js';
export type {BidiCommandParameterParser} from './BidiParser.js';
